import { Directive, HostListener, ElementRef, inject } from '@angular/core';

/**
 * Forces the value of a text input to UPPERCASE while typing / pasting.
 * Used for every "ville" (city) and CIN field — the database enforces the same rule with triggers.
 * Dispatches a second `input` event so reactive forms, ngModel and `(input)` handlers all receive the uppercase value.
 */
@Directive({
  selector: '[appUppercase]',
  standalone: false
})
export class UppercaseDirective {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);

  @HostListener('input') onInput(): void {
    const input = this.el.nativeElement;
    const upper = (input.value ?? '').toUpperCase();
    if (upper === input.value) return;
    const start = input.selectionStart, end = input.selectionEnd;
    input.value = upper;
    try { input.setSelectionRange(start, end); } catch { /* input types without selection */ }
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
